import classNames from 'clsx';
import filter from 'lodash/filter';
import React, { createRef } from 'react';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import OutsideClickHandler from 'react-outside-click-handler';
import { toast as toastr } from 'react-toastify';
import Collapse from 'react-bootstrap/lib/Collapse';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';
import IconAddDownloadFolder from '~/components/svg/icon-add-download-folder.svg';
import IconAddDownloadFolderActive from '~/components/svg/icon-add-download-folder-active.svg';
const roles = Config.getRoles();

@withI18next()
class ButtonAddCartComponent extends React.Component {
  addCartButtonRef = createRef();

  constructor(props) {
    super(props);
    this.shareWorker = null;
    this.state = {
      showPopover: false,
      openAddTocard: false,
    };
  }

  componentDidMount() {
    if ('serviceWorker' in navigator && window.SharedWorker) {
      const shareWorker = new SharedWorker('/ssw.js');
      if (shareWorker) {
        this.initShareWorker(shareWorker);
      }
    }
  }

  hidePopover = (e) => {
    if (!this.addCartButtonRef || !this.addCartButtonRef.current) return;
    if (this.addCartButtonRef.current.contains(e.target)) return;
    if (
      ['mypage-link-primary', 'popover-content', 'photo_text-color'].includes(
        e.target.className,
      )
    ) {
      return;
    }
    this.setState((state) => {
      if (state.showPopover) {
        this.addCartButtonRef.current.click();
      }
      return { showPopover: false };
    });
  };

  initShareWorker(shareWorker) {
    if (!shareWorker) {
      return;
    }
    this.shareWorker = shareWorker;
    this.shareWorker.port.start();
  }

  addDLFolder = (e) => {
    const { profile, isAuthenticated } = this.props;
    const { showPopover } = this.state;
    if (
      !isAuthenticated ||
      (profile.role !== Config.getRoles().PREMIUM &&
        profile.role !== Config.getRoles().PREMIUM_NO_ADS)
    ) {
      if (!showPopover && !Config.isIllustAC()) {
        this.setState({
          showPopover: true,
        });
      }
      return;
    }
    const {
      photo,
      photos,
      addPhotoInCart,
      toggleSlider,
      toggleSliderFunc,
      layout,
      setIsPhotoCartOpen,
      sizeSelect,
      t,
      isAIPhoto,
    } = this.props;
    let photosChoose;
    try {
      photosChoose = JSON.parse(localStorage.getItem('photos')) || [];
    } catch (e) {
      photosChoose = [];
    }
    if (photosChoose.length) {
      if (photosChoose.length >= process.env.NUMBER_DOWNLOAD) {
        return toastr.warning(
          t('Maximum_download', { number: process.env.NUMBER_DOWNLOAD }),
        );
      }
      if (
        filter(photosChoose, { id: photo.id, sizeSelect: sizeSelect.type })
          .length > 0
      ) {
        return toastr.warning(t('Image_added'));
      }
    }
    if (!layout.isPhotoCartOpen) {
      setIsPhotoCartOpen(true);
    }
    let photoSave = null;
    if (isAIPhoto) {
      photoSave = {
        id: 1000000000 + photos.length, // Fake id since AI photo has no id
        thumbnail: photo.image_url,
        sizeSelect: 'AI-256-256', // Fake sizeSelect
        type: 'AI-GEN', // Fake type,
        active: true,
      };
    } else {
      photoSave = {
        id: photo.id,
        thumbnail: photo.thumbnail,
        sizeSelect: sizeSelect.type || '',
        type: sizeSelect.format || sizeSelect.type || '',
        active: true,
      };
    }
    addPhotoInCart(photoSave);
    // photos.unshift(photoSave);
    // const photoClones = photos.map(photo => ({ ...photo, active: false }));
    // localStorage.setItem('photos', JSON.stringify(photoClones));
    if (this.shareWorker) {
      this.shareWorker.port.postMessage({
        message: 'load',
        id: 1,
        type: 'add',
      });
    }
  };

  render() {
    const { t, lng, photo, profile } = this.props;
    const { showPopover } = this.state;

    // let popoverAddDL = <div />;
    // if (showPopover) {
    const popoverAddDL = (
      <Popover
        id="download-folder-popover"
        style={{ width: 220, textAlign: 'center' }}
      >
        <span
          style={{ fontSize: 12 }}
          className={Config.getPrefixContent('text-color')}
          dangerouslySetInnerHTML={{
            __html: t('bulk_download_tip'),
          }}
        />
      </Popover>
    );
    // }

    const downloadFolderButtonClassName = classNames(
      'btn',
      `btn-${Config.serviceType}`,
      'btn-block',
      'btn-add-folder',
    );

    return (
      <div>
        {Config.isIllustAC() ? (
          <button
            className="btn-illust-add-folder"
            onClick={this.addDLFolder}
            disabled={
              profile.role === roles.PREMIUM ||
              profile.role === roles.PREMIUM_NO_ADS
                ? false
                : true
            }
          >
            {profile.role === roles.PREMIUM ||
            profile.role === roles.PREMIUM_NO_ADS ? (
              <IconAddDownloadFolder width="24" style={{ marginRight: 16 }} />
            ) : (
              <IconAddDownloadFolderActive
                width="24"
                style={{ marginRight: 16 }}
              />
            )}
            {t('ill_add_to_download_folder')}
          </button>
        ) : (
          <OutsideClickHandler onOutsideClick={this.hidePopover}>
            <OverlayTrigger
              trigger={['hover', 'focus']}
              placement="bottom"
              overlay={popoverAddDL}
              onClick={() => {
                this.setState({ openAddTocard: !this.state.openAddTocard });
              }}
            >
              <button
                ref={this.addCartButtonRef}
                className={downloadFolderButtonClassName}
                onClick={this.addDLFolder}
                disabled={photo.assets && !photo.assets.length}
              >
                <IconAddDownloadFolder
                  className="icon-add-download-folder"
                  width="24"
                  style={{ marginRight: 16 }}
                />
                <IconAddDownloadFolderActive
                  className="icon-add-download-folder-active"
                  width="24"
                  style={{ marginRight: 16 }}
                />
                {t('add_to_download_folder')}
              </button>
            </OverlayTrigger>
            <Collapse in={showPopover} className="data-collapse">
              <p
                className="note"
                dangerouslySetInnerHTML={{
                  __html: t('message_check_role_premium_bulk_download', {
                    href: `${Config.getSiteURL()}/premium`,
                  }),
                }}
              ></p>
            </Collapse>
          </OutsideClickHandler>
        )}
        <style jsx>
          {`
            .btn-add-folder {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              margin-top: 16px;
              font-size: 16px;
              border-radius: 4px;
              font-weight: 600;
              background: #fff;
              height: 48px;
              border: 2px solid ${themeVariables.colors.bodyText};
              color: ${themeVariables.colors.bodyText};
            }
            .btn-add-folder:hover {
              color: #fff;
              background: ${themeVariables.colors.bodyText};
            }
            .note {
              margin-top: 8px;
            }
            .btn-illust-add-folder {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              padding: 8px 20px;
              height: 44px;
              margin-top: 16px;
              width: 192px;
              ${profile.role === roles.PREMIUM ||
              profile.role === roles.PREMIUM_NO_ADS
                ? 'border: 1px solid #7A7A7A;background: #ffffff;'
                : 'background: #E3E3E3;color:#ffffff;border:none;'}
              border-radius: 40px;
            }
            .btn-illust-add-folder:hover {
              opacity: ${profile.role === roles.PREMIUM ||
              profile.role === roles.PREMIUM_NO_ADS
                ? '0.8'
                : '1'};
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .btn-illust-add-folder {
                width: 170px;
                padding: 4px 4px;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .mypage-link-primary {
              color: ${themeVariables.colors.primary};
              text-decoration: underline !important;
            }
            .mypage-link-primary:hover {
              color: ${themeVariables.colors.primary};
              opacity: 0.9;
              text-decoration: underline !important;
            }

            .btn-add-folder:hover .icon-add-download-folder,
            .btn-add-folder:focus .icon-add-download-folder,
            .btn-add-folder .icon-add-download-folder-active {
              display: ${Config.isIllustAC() ? 'initial' : 'none'};
            }
            .btn-add-folder .icon-add-download-folder,
            .btn-add-folder:hover .icon-add-download-folder-active,
            .btn-add-folder:focus .icon-add-download-folder-active {
              display: initial;
            }
          `}
        </style>
      </div>
    );
  }
}

ButtonAddCartComponent.defaultProps = {
  photo: {},
  photos: [],
  addPhoto: () => ({}),
  loadPhotos: () => ({}),
  sizeSelect: {},
  profile: {},
};
export default ButtonAddCartComponent;
